import BaseModel from "./BaseModel";

export class AllocationGroup extends BaseModel {
  /* eslint-disable-next-line */
  constructor(props) {
    super(props);
  }
}
